import { styled } from '@mui/material/styles';

export const StyledRoot = styled('div')(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  height: 'calc(100% - 64px)',

  [theme.breakpoints.down('xl')]: {
    position: 'relative',
    height: 'auto',
  },

  '& .MuiTab-labelIcon': {
    minHeight: 50,
  },

  '@media print': {
    position: 'relative',
  },

  '& .content': {
    padding: theme.spacing(2),

    '& .buttonRow button': {
      margin: theme.spacing(1),
    },
  },
}));

export const StyledQuestionsContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  maxWidth: '1040px',
  margin: 'auto',

  '& .assessmentContainer': {
    width: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: isMobile ? undefined : 0,
    overflow: 'hidden',
    overflowY: 'auto',
  },

  '& .assessmentTitle': {
    margin: theme.spacing(2),
  },

  '&.resultsContainer': {
    maxWidth: '1040px',
    margin: `${theme.spacing(2)} ${theme.spacing(2)}`,

    '& .questionContainer': {
      width: isMobile ? '100%' : '40%',
    },

    '& .answerContainer': {
      width: isMobile ? '80%' : '50%',
      maxWidth: 500,
      margin: theme.spacing(2),
      padding: theme.spacing(1),
      backgroundColor: theme.palette.action.disabledBackground,
      borderRadius: theme.spacing(1),
    },

    '& .question': {
      flex: 1,
      maxWidth: 500,
      margin: `${theme.spacing(5)} 0`,
      minHeight: 'auto',
    },

    '& .showAnswer': {
      '& .checkpointOption': {
        backgroundColor: theme.palette.action.disabledBackground,
        margin: `${theme.spacing(1)} ${theme.spacing(1)} 0 0`,
        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,

        '&.incorrect': {
          '&.selected': {
            backgroundColor: theme.palette.error.main,
          },

          '& .MuiIcon-root': {
            color: theme.palette.error.main,
          },
        },
        '&.correct': {
          '&.selected': {
            backgroundColor: theme.palette.success.main,
          },

          '& .MuiIcon-root': {
            color: theme.palette.success.main,
          },
        },

        '& .MuiIcon-root': {
          padding: theme.spacing(1),
        },

        '&.selected.incorrect .MuiIcon-root, &.selected.correct .MuiIcon-root': {
          color: theme.palette.common.white,
        },
      },
    },
  },

  '& .buttonContainer': {
    position: isMobile ? 'fixed' : 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
  },

  '& .buttonRow': {
    width: '100%',
    '& button': {
      margin: theme.spacing(1),
    },
  },

  '& .prog': {
    width: isMobile ? '95%' : '100%',
    maxWidth: 500,
  },
  '& .question': {
    maxWidth: 500,
    margin: '0 auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),

    '&.assessmentEnd': {
      textAlign: 'center',
      '& .submitRow': {
        flexDirection: 'column',

        '& .btn': {
          marginTop: theme.spacing(2),
          marginBottom: theme.spacing(2),
          width: 250,
          textAlign: 'center',

          '& button': {
            margin: theme.spacing(1),
          },
        },
      },
    },

    '&.intro': {
      textAlign: 'center',
      minHeight: undefined,

      '& .header': {
        paddingTop: theme.spacing(3),
      },
    },

    '& .submitRow': {
      marginTop: theme.spacing(2),
    },

    '& .header': {
      marginBottom: theme.spacing(2),
    },
    '& .options': {
      margin: theme.spacing(2),

      '&.boolean': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',

        '& .checkpointOption': {
          paddingRight: theme.spacing(2),
        },
      },
    },
    '& .checkpointOption': {
      borderRadius: theme.spacing(1),
      '&:hover': {
        backgroundColor: isMobile ? undefined : theme.palette.action.disabledBackground,
        cursor: 'pointer',
      },
    },
  },
}));
